import { PropsWithChildren } from 'react';

import { Text } from '@thefarmersfront/kitchen';

import styles from './SummaryItem.module.scss';

interface SummaryItemProps {
  title: string;
}

const SummaryItem = ({ title, children }: PropsWithChildren<SummaryItemProps>) => {
  return (
    <div className={styles.item}>
      <Text size="small" weight="semi-bold">
        {title}
      </Text>
      {children}
    </div>
  );
};

export { SummaryItem };
